export default class AbstractElement {

    constructor() {
        if (this.constructor.name === 'AbstractElement') {
            throw new TypeError("Cannot construct Abstract instances directly");
        }
    }

    update(context) {
        throw new TypeError("Must override method");
    }
}


// WEBPACK FOOTER //
// ./src/components/cchart/AbstractElement.js